(() => {
  const initialized = Symbol.for('origenbath.marketLinks');
  if (window[initialized]) return;
  const stores = new Set(["origenbath.de","origenbath.at","origenbath.be","origenbath.cz","origenbath.dk","origenbath.si","origenbath.ee","origenbath.fi","origenbath.fr","origenbath.gr","origenbath.hu","origenbath.it","origenbath.lv","origenbath.lt","origenbath.lu","origenbath.nl","origenbath.pl","origenbath.pt","origenbath.ro","origenbath.se"]);
  const normalizeHost = (host) => host.toLowerCase().replace(/^www\./, '');
  if (!stores.has(normalizeHost(window.location.hostname))) return;
  window[initialized] = true;
  const configuredRoot = document.currentScript?.dataset.rootUrl || window.Shopify?.routes?.root || '/';
  const root = configuredRoot.startsWith('/') && !configuredRoot.startsWith('//') ? `${configuredRoot.replace(/\/$/, '')}/` : '/';
  const reviewSelector = 'a.jdgm-carousel-item__product[href], a.jdgm-rev__prod-link[href], .jdgm-rev__prod-link a[href], .jdgm-product-name a[href]';
  const countrySelector = '.ob-home-countries__track a[href]';
  const selector = `${reviewSelector}, ${countrySelector}`;
  const theme = window.Shopify?.theme;
  const previewId = ['unpublished', 'development'].includes(theme?.role) && /^\d+$/.test(String(theme?.id || '')) ? String(theme.id) : null;

  const countryThemes = {"origenbath.es":"200834023768","origenbath.ad":"200834023768","origenbath.cn":"200834023768","origenbath.us":"200834023768","origenbath.co.uk":"200834023768","origenbath.ch":"200834023768","origenbath.ae":"200834023768","origenbath.id":"200834023768","origenbath.no":"200834023768","origenbath.pt":"210695291219","origenbath.fr":"210695291219","origenbath.it":"210695291219","origenbath.de":"210695291219","origenbath.at":"210695291219","origenbath.be":"210695291219","origenbath.nl":"210695291219","origenbath.pl":"210695291219","origenbath.se":"210695291219","origenbath.cz":"210695291219","origenbath.dk":"210695291219","origenbath.si":"210695291219","origenbath.ee":"210695291219","origenbath.fi":"210695291219","origenbath.gr":"210695291219","origenbath.hu":"210695291219","origenbath.lv":"210695291219","origenbath.lt":"210695291219","origenbath.lu":"210695291219","origenbath.ro":"210695291219","origenbath.sk":"209867014481","origenbath.hr":"209867014481","origenbath.mt":"209867014481","origenbath.bg":"209867014481"};

  const localize = (anchor) => {
    if (!anchor.matches(selector)) return;
    let source;
    try { source = new URL(anchor.getAttribute('href'), window.location.origin); } catch (_) { return; }
    if (!['http:', 'https:'].includes(source.protocol) || source.username || source.password) return;
    if (anchor.matches(countrySelector) && previewId) {
      const destinationTheme = countryThemes[normalizeHost(source.hostname)];
      if (!destinationTheme) return;
      source.searchParams.set('preview_theme_id', destinationTheme);
      if (anchor.href !== source.href) anchor.setAttribute('href', source.href);
      return;
    }
    if (!stores.has(normalizeHost(source.hostname))) return;
    if (anchor.matches(countrySelector)) {
      if (!previewId) return;
      source.searchParams.set('preview_theme_id', previewId);
      if (anchor.href !== source.href) anchor.setAttribute('href', source.href);
      return;
    }
    const product = source.pathname.match(/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?(products\/[^/]+\/?)$/i);
    const storeHome = /^\/(?:[a-z]{2}(?:-[a-z]{2})?\/?)?$/i.test(source.pathname);
    if (!product && !storeHome) return;
    const destination = new URL(`${root}${product ? product[1] : ''}`, window.location.origin);
    destination.search = source.search;
    destination.hash = source.hash;
    if (anchor.href !== destination.href) anchor.setAttribute('href', destination.href);
  };

  const update = (rootElement) => {
    if (rootElement.nodeType === 1) localize(rootElement);
    rootElement.querySelectorAll?.(selector).forEach(localize);
  };

  const start = () => {
    update(document);
    const observer = new MutationObserver((changes) => {
      changes.forEach((change) => {
        if (change.type === 'attributes') localize(change.target);
        else change.addedNodes.forEach(update);
      });
    });
    observer.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['href'] });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
